import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import SvgImage from "../../Icons/Icons";
import { useNavigate } from "react-router-dom";
import Papa from "papaparse";
import TripStatusData from "../../TripAnalysis/SubComponents/TripDataView";
import BulkFuelVendorView from "../../VendorNew/Components/BulkFuelVendorView";
import * as XLSX from "xlsx";

function BulkProcessScreen(props) {
  const { toggle, modal, setModal,setRefresh,
    refresh } = props;
  const [data, setData] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClose = () => {
    setModal(!modal);
  };

  // filesave has csv file exctract the data from it and show it in the table

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width model-Radius"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <ModalBody
          className="transactionModalBody-1"
          //   style={{ marginTop: "25px" }}
        >
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <div
              className="d-flex flex-column"
              style={{
                textAlign: "center",
              }}
            >
              <div>
                <SvgImage name="processingIcon" />
              </div>
              <div>Processing</div>
              <div>File uploaded successfully.Transactions in Process</div>
              <div>
                <button
                  type="button"
                  className="greenButtonNew btn-secondary"
                  style={{ width: "200px" }}
                  onClick={() => {
                    setRefresh(!refresh)
                    props?.setView()
                }}
                >
                  Check Responses
                </button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default BulkProcessScreen;
